import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PopoverController} from '@ionic/angular';
import {SimpleSelectPopoverComponent} from './simple-select-popover.component';
import {SmallSelectItem} from '../../../../services/common-datatypes';
import {AutoUnsubscribe, RequiredInput} from '../../../../decorators/common.decorators';
import {StateStorageService} from '../../../../services/state-storage.service';
import {Subscription} from 'rxjs';
import {skip} from 'rxjs/operators';

@Component({
    selector: 'app-simple-select',
    templateUrl: './simple-select.component.html',
    styleUrls: ['./simple-select.component.scss']
})
export class SimpleSelectComponent implements OnInit, OnDestroy {

    public fullName: string = '';
    @Input() inline = false;
    @Input() autoOpen = false;
    @Input() multiple = false;
    @Input() allowEmpty = true;
    @Input() @RequiredInput translationPrefix!: string;
    @Input() @RequiredInput selectList!: SmallSelectItem[];
    private _selectedItems: SmallSelectItem[] = [];
    @Input() @RequiredInput
    set selectedItems(list: SmallSelectItem[]) {
        if (!list) return;
        this._selectedItems = list;
        this.updateLastSelectedIds();
    }

    @Output() selectedItemsChange = new EventEmitter<SmallSelectItem[]>();

    private lastSelectedIds: Array<string | number> = [];

    @AutoUnsubscribe('ngOnDestroy')
    private subscriptions: Subscription[] = [];

    constructor(private popoverCtrl: PopoverController,
                private appState: StateStorageService) {
    }

    ngOnInit(): void {
        if (this.autoOpen) this.openDropDown(new Event(''));
    }

    ngOnDestroy(): void {
    }

    public setFullname(): void {
        let tempName = '';
        if (this._selectedItems && (0 < this._selectedItems.length)) {
            this._selectedItems.forEach((item: SmallSelectItem) => {
                if (item.name) tempName += ', ' + item.name;
            });
        }
        if (2 >= tempName.length) this.fullName = '';
        this.fullName = tempName.substring(2);
    }

    openDropDown(event: Event) {
        if (event) event.stopPropagation();
        this.popoverCtrl.create({
            component: SimpleSelectPopoverComponent,
            componentProps: {
                multiple: this.multiple,
                selectList: this.selectList,
                selectedItems: this._selectedItems,
            },
            event: event,
            cssClass: 'autosize-popover',
            animated: false,
        }).then((popover: HTMLIonPopoverElement) => {
            popover.present();
            popover.onDidDismiss().then(() => {
                this.emitIfChanged();
            });
            this.subscriptions.push(this.appState.navigation$.pipe(skip(1))
                .subscribe(() => {
                    popover.dismiss();
                })
            );
        });
    }

    clearSelect(event: Event) {
        if (event) event.stopPropagation();
        this._selectedItems.length = 0;
        this.emitIfChanged();
    }

    private updateLastSelectedIds() {
        this.lastSelectedIds = [];
        this._selectedItems.forEach((data) => {
            this.lastSelectedIds.push(data.id);
        });
        this.setFullname();
    }

    private emitIfChanged() {
        let same = false;
        if (this._selectedItems.length === this.lastSelectedIds.length) {
            same = true;
            for (let i = 0; i < this._selectedItems.length; i++) {
                if (this.lastSelectedIds[i] !== this._selectedItems[i].id) {
                    same = false;
                    break;
                }
            }
        }
        if (!same) {
            this.updateLastSelectedIds();
            this.selectedItemsChange.emit(this._selectedItems);
        }
    }

}
